export function NavigateTo(e: Event, page: string) {
  window.location.href = `${page}`
  e.preventDefault();
}

export function OpenExternalLink(link: string, isMailLink: boolean) {
  window.open(isMailLink ? `mailto:${link}` : link, "_blank")
}